import React from "react";
import {Outlet} from "react-router-dom";
import {useIsAuthed} from "./hooks";

export const ProtectedRoutes = () => {
    const isAuthed = useIsAuthed()
    return isAuthed ? (<Outlet/>) : <React.Fragment/>
}